import { Method as AxiosMethod } from 'axios'
import { fetchNoCatch } from '@dhl/fetch'

const baseUrl = '/api/address-book'

export const client = async <T>({
  url = '',
  method = 'GET',
  params,
  data,
  headers,
  signal,
}: {
  url: string
  method: AxiosMethod
  params?: string | string[][]
  data?: unknown
  responseType?: string
  headers?: Record<string, string>
  signal?: AbortSignal
}): Promise<T> =>
  fetchNoCatch({
    url: `${baseUrl}${url}${params ? `?${new URLSearchParams(params)}` : ''}`,
    method,
    headers,
    ...(data ? { body: JSON.stringify(data) } : {}),
    signal,
    timeout: 30000,
  })
